import Auth from './Auth'
import AuthAdmin from './AuthAdmin'
import AuthDashboard from './AuthDashboard'

export default {
  Auth,
  AuthAdmin,
  AuthDashboard
}